<template>
  <Dialog
    :closable="false"
    :showHeader="false"
    :style="{ width: '50vw' }"
    :breakpoints="{ '960px': '90vw' }"
    position="top"
  >
    <div class="tw-mt-6">
      <FeaturedFeedbackContainerItem
        :review="review"
        :showEllipsis="false"
        :viewIsModal="true"
        :pt="{
          root: { class: '!tw-shadow-none' },
          content: { class: '' },
        }"
      />
      <FeedbackContainerResponseItem v-if="review.response.message" :response="review.response" />
      <button class="tw-absolute tw-right-0 tw-top-0 tw-mr-2 tw-mt-2" @click="closeModal" aria-label="Close review">
        <font-awesome-icon :icon="['fas', 'times']" class="tw-text-xl" />
      </button>
    </div>
  </Dialog>
</template>

<script setup>
import FeaturedFeedbackContainerItem from './FeaturedFeedbackContainerItem.vue';
import FeedbackContainerResponseItem from './FeedbackContainerResponseItem.vue';

const props = defineProps({
  review: Object,
});

const emit = defineEmits(['update:visible']);

const closeModal = () => {
  emit('update:visible', false);
};
</script>

<style scoped>
:global(.p-dialog .p-dialog-content) {
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: var(--border-radius);
}
</style>
